import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_PROCESOS_JURIDICOS

export default class categoriasFallosService {
  paginate (params) {
    return http.get(`${baseUrl}/estados-fallos/paginate`, {
      params,
      headers: {
        loading: true
      }
    })
  }
}
